import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { MsisdnChangeState } from '../types/msisdnChange';

export const useMsisdnChangeStore = create<MsisdnChangeState>()(
  devtools(
    set => ({
      sessionData: null,
      paymentEvent: null,
      result: null,
      paymentDetails: null,

      setSessionData: sessionData =>
        set({ sessionData }, false, 'setSessionData'),
      setPaymentEvent: paymentEvent =>
        set({ paymentEvent }, false, 'setPaymentEvent'),
      setResult: result => set({ result }, false, 'setResult'),
      setPaymentDetails: paymentDetails =>
        set({ paymentDetails }, false, 'setPaymentDetails'),
      clearMsisdnChange: () =>
        set(
          {
            sessionData: null,
            paymentEvent: null,
            result: null,
            paymentDetails: null,
          },
          false,
          'clearMsisdnChange',
        ),
    }),
    { name: 'MsisdnChangeStore' },
  ),
);
